import { useEffect, useState } from 'react';
import { ReviewHeader } from '../components/review/ReviewHeader';
import { ReviewImageCard } from '../components/review/ReviewImageCard';
import { ReviewLoading } from '../components/review/ReviewLoading';
import { createDownloadRequest, getUpload, updateImagePrintVersion } from '../services/adminService';

export const UploadDetailPage = ({ code, onBack }) => {
  const [upload, setUpload] = useState(null);
  const [downloadRequest, setDownloadRequest] = useState(null);
  const [savingVersionByImageId, setSavingVersionByImageId] = useState({});

  useEffect(() => {
    getUpload(code).then(setUpload);
  }, [code]);

  const handleVersionChange = async (imageId, printVersion) => {
    setSavingVersionByImageId((current) => ({ ...current, [imageId]: true }));
    setUpload((current) => updateLocalImageVersion(current, imageId, printVersion));

    try {
      const updated = await updateImagePrintVersion(code, imageId, printVersion);
      setUpload(updated);
    } finally {
      setSavingVersionByImageId((current) => {
        const next = { ...current };
        delete next[imageId];
        return next;
      });
    }
  };

  const handleDownload = async () => {
    const request = await createDownloadRequest(code);
    setDownloadRequest(request);
  };

  if (!upload) {
    return <ReviewLoading onBack={onBack}/>;
  }

  return (
    <>
      <ReviewHeader
        downloadRequest={downloadRequest}
        onBack={onBack}
        onDownload={handleDownload}
        upload={upload}
      />

      <div className="row m-0">
        {upload.images.map((image) => (
          <ReviewImageCard
            key={image.id}
            image={image}
            savingVersion={Boolean(savingVersionByImageId[image.id])}
            onVersionChange={handleVersionChange}
          />
        ))}
      </div>
    </>
  );
}

function updateLocalImageVersion(upload, imageId, printVersion) {
  if (!upload) {
    return upload;
  }

  return {
    ...upload,
    images: upload.images.map((image) => (
      image.id === imageId ? { ...image, printVersion } : image
    )),
  };
}

